// Shared "5m ago" / "3h ago" / "2d ago" relative-time formatter --
// extracted 2026-10-07 from Header.js's bell dropdown so the redesigned
// full notifications page uses the exact same wording instead of a
// second, possibly-drifting copy.
const formatRelativeTime = (dateStr) => {
  if (!dateStr) return "";
  const diffMs = Date.now() - new Date(dateStr).getTime();
  const diffMin = Math.round(diffMs / 60000);
  if (diffMin < 1) return "just now";
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffHr = Math.round(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h ago`;
  return `${Math.round(diffHr / 24)}d ago`;
};

export default formatRelativeTime;
